import { ActionType, TableColumn } from "../../../Component/Model/Table/Table";
import { VerificationAgencyContacts } from "../../../Component/Model/Dto/VerificationAgency/VerificationAgencyContacts";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { ActionsCell } from "../../../Component/Common/Components/DataTable/ActionsCell";

interface VAContactRow {
    Name: string;
    Surname: string;
    Email: string;
    ContactNumber: string;
    Position: string;
    Actions: ActionType[];
}

export interface VAContactTable {
    columns: Array<TableColumn>;
    rows: Array<VAContactRow>;
}

export function VAContactTableMapper(dataObject: VerificationAgencyContacts.ContactResult[], deleteContact: (id: number) => void, updateContact: (id: number) => void): VAContactTable {
    const columns = [
        { Header: 'Name', accessor: 'Name', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Surname', accessor: 'Surname', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Email', accessor: 'Email', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Contact Number', accessor: 'ContactNumber', Cell: ({ value }: any) => <DefaultCell value={value} />},
        { Header: 'Position', accessor: 'Position', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true }
    ];
    if (dataObject !== undefined && dataObject.length > 0) {
        const rows = dataObject.map((item: VerificationAgencyContacts.ContactResult, index: number) => ({
            Name: item.contactFirstName,
            Surname: item.contactLastName,
            Email: item.contactEmail,
            ContactNumber: item.contactTelephone,
            Position: item.contactPosition,
            Actions: [
                {
                    key: index.toString(),
                    label: 'Edit',
                    action: () => {
                        updateContact(item.verificationAgencyContactId);
                    },
                    icon: {
                        color: 'primary',
                        name: 'edit'
                    }
                },
                {
                    key: index.toString(),
                    label: 'Delete',
                    action: () => {
                        deleteContact(item.verificationAgencyContactId);
                    },
                    icon: {
                        color: 'error',
                        name: 'delete'
                    }
                },
            ]

        }));
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}
